import { enUS, pl } from "date-fns/locale";

export const LOCALES: { [key: string]: Locale } = {
  en: enUS,
  pl: pl,
};

export const DEFAULT_LOCALE = enUS;
